import { EventDispatcher, isMobileView, showElement } from '@utils/toolbox';

const className = 'abDisplayMessage';

export class DisplayMessage {
	/**
	 * @param {Element} parentWrapper - Element to render display message inside
	 * @param {Object} config
	 * @param {string} config.style
	 * @param {string} config.messageText
	 * @param {string} config.buttonText
	 * @param {string} config.callBack
	 */
	constructor (parentWrapper, config) {
		this.html = parentWrapper;
		this.style = config.style || null;
		this.messageText = config.messageText || 'messageText';
		this.buttonText = config.buttonText || 'buttonText';
		this.callBack = config.callBack || null;
		this.isOpen = false;
		this.setBodyOverflowHidden = false;

		this.render();
		this.events();
	}

	render () {
		const html = document.createElement('div');

		const content = `
				<div class="${className}__msg">
					<span>${this.messageText}</span>
				</div>
				<button class="${className}__btn">
					<span>${this.buttonText}</span>
				</button>
			`;

		html.className = className;
		html.innerHTML = content;
		html.classList.add(`${className}--column`);
		html.classList.add(`${className}--fullPage`);
		html.classList.add(`${className}--withImageBg`);

		if (this.style) {
			html.classList.add(`${className}--${this.style}`);
		}

		this.html.insertAdjacentElement('beforeend', html);
		this.html = html;
	}

	show () {
		this.isOpen = true;

		if (window.scrollY) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}

		this.html.style.display = 'flex';

		return this;
	}

	hide () {
		this.isOpen = false;


		if (this.setBodyOverflowHidden) {
			this.setBodyOverflowHidden = false;
			document.body.style.overflow = '';
		}

		this.html.style.display = '';

		return this;
	}

	/**
	 *
	 * @param {Boolean} isVisible
	 */
	toggleDisplay (isVisible) {
		showElement(this.html, isVisible);
	}

	/**
	 * @param {Object} updates
	 * @param {string} updates.style
	 * @param {string} updates.messageText
	 * @param {string} updates.buttonText
	 * @param {string} updates.callBack
	 */
	update (updates) {
		this.html.querySelector(`.${className}__msg span`).innerHTML = updates.messageText;
		this.html.querySelector(`.${className}__btn span`).innerHTML = updates.buttonText;
		this.callBack = updates.callBack;
		if (updates.style) {
			this.html.classList.add(`${className}--${updates.style}`);
		}
	}

	events () {
		let resizeTimer;

		this.html.addEventListener('click', (e) => {
			const elem = e.target;

			if (elem.closest('button')) {
				e.preventDefault();

				if (typeof this.callBack === 'function') {
					this.callBack();
				}
			}
		}, false);

		window.addEventListener('resize', (event) => {
			if (resizeTimer) {
				cancelAnimationFrame(resizeTimer);
			}

			resizeTimer = requestAnimationFrame(() => {
				const isMobile = isMobileView();

				if (this.isOpen) {
					this.setBodyOverflowHidden = isMobile;
					document.body.style.overflow = isMobile ? 'hidden' : '';
				}
			});
		});

		EventDispatcher.addEventListener('displayMessage.update', (updates) => {
			this.update(updates);
		});
	}
}
